
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cancellation-and-refundpolicies",
      function () {
        return require("private-next-pages/cancellation-and-refundpolicies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cancellation-and-refundpolicies"])
      });
    }
  